export const performanceZh = {
  title: '绩效管理',
  subtitle: '目标设定、考核评估与绩效发展',

  // 导航
  nav: {
    admin: '管理',
  },

  // 组织选择
  organization: {
    select: '选择组织',
    current: '当前',
    loading: '加载中...',
    all: '全部组织',
  },

  // 管理员配置概览（周期为主）
  adminOverview: {
    title: '配置概览',
    // 空状态
    noCycle: '暂无绩效周期',
    noCycleDesc: '创建第一个绩效周期，开始管理团队绩效',
    createCycle: '创建周期',
    // 周期信息
    allCycles: '所有周期',
    // 统计卡片
    kpiProgress: 'KPI 评估',
    e360Progress: '360 评估',
    calibration: '绩效校准',
    confirmed: '已确认',
    completed: '已完成',
    inProgress: '进行中',
    done: '已完成',
    notStarted: '未开始',
    // 快捷操作
    quickActions: '快捷操作',
    manageKpi: '管理 KPI 评估',
    manageCalibration: '进入绩效校准',
    publishResults: '发布绩效结果',
    // 阶段配置提示
    stageHints: {
      draft: {
        title: '草稿阶段配置',
        desc: '请为本周期选择绩效等级配置方案',
        noConfigs: '暂无等级配置，请先创建',
        createConfig: '创建配置',
        selectLabel: '选择等级配置',
        selectPlaceholder: '-- 请选择 --',
        default: '默认',
        manageConfigs: '管理等级配置',
        apply: '应用到本周期',
        applied: '已应用',
        advance: '发布周期',
        advanceConfirm: '确认发布此周期并开始目标设定？',
      },
      goalSetting: {
        title: '目标设定阶段',
        desc: '员工正在设定 KPI 目标，可自由填写添加',
        action: '查看 KPI 设定',
        advance: '开始执行',
        advanceConfirm: '确认结束目标设定并开始执行？',
      },
      inProgress: {
        title: '执行阶段',
        desc: '周期执行中，员工正在推进目标',
        action: '查看进度',
        advance: '开始评估',
        advanceConfirm: '确认结束执行并开始评估？',
      },
      evaluating: {
        title: '评估阶段',
        desc: '员工正在进行自评和互评，请关注评估进度',
        action: '查看评估进度',
        advance: '开始校准',
        advanceConfirm: '确认结束评估并开始校准？',
      },
      calibrating: {
        title: '校准阶段',
        desc: '请对员工绩效等级进行校准，确保评级公平一致',
        action: '进入绩效校准',
        advance: '发布结果',
        advanceConfirm: '确认完成校准并发布绩效结果？发布后员工将收到结果通知。',
      },
      confirming: {
        title: '结果确认阶段',
        desc: '绩效结果已发布，等待员工确认。员工可查看结果并确认或提出申诉。',
        action: '查看确认进度',
        advance: '完成周期',
        advanceConfirm: '确认完成此绩效周期？未确认的员工将视为默认接受结果。',
      },
      completed: {
        title: '周期已完成',
        desc: '所有员工已确认绩效结果，可在准备好后归档。',
        advance: '归档周期',
        advanceConfirm: '确认归档此周期？归档后为只读状态。',
      },
      advancing: '处理中...',
    },
    // 目标设定进度
    goalProgress: {
      title: '目标设定进度',
      submitted: '人已提交',
      submittedLabel: '已提交',
      draftLabel: '草稿中',
      notStartedLabel: '未开始',
      deptProgress: '部门进度',
      deptName: '部门',
      deptProgressLabel: '进度',
      deptSubmitted: '已提交',
      deptPending: '人未提交',
      pendingTitle: '未提交人员',
      kpiCount: '个 KPI',
      statusDraft: '草稿',
      statusNotStarted: '未开始',
      showAll: '查看全部',
      people: '人',
      collapse: '收起',
    },
    // 评估进度
    evalProgress: {
      title: '评估进度',
      selfEval: '自评',
      managerEval: '上级评',
      selfCompleted: '人已自评',
      managerCompleted: '人已上级评',
      completedLabel: '已完成',
      pendingLabel: '未完成',
      deptProgress: '部门进度',
      pendingTitle: '未完成评估人员',
      e360Eval: '360评估',
      e360Completed: '人已完成',
      pendingSelf: '待自评',
      pendingManager: '待上级评',
      pendingBoth: '待自评+上级评',
      pending360: '待360',
      showAll: '查看全部',
      people: '人',
      collapse: '收起',
    },
    // 校准进度
    calProgress: {
      title: '校准进度',
      calibrated: '人已校准',
      gradeDistribution: '等级分布',
      deptProgress: '部门校准',
      deptCalibrated: '已校准',
      pendingTitle: '待校准人员',
      avgScore: '均分',
      showAll: '查看全部',
      people: '人',
      collapse: '收起',
    },
    // 确认进度
    confirmProgress: {
      title: '结果确认进度',
      confirmed: '人已确认',
      confirmedLabel: '已确认',
      pendingLabel: '待确认',
      appealedLabel: '已申诉',
      deptProgress: '部门确认进度',
      deptConfirmed: '已确认',
      pendingTitle: '待确认人员',
      showAll: '查看全部',
      people: '人',
      collapse: '收起',
    },
    // 结果汇总
    resultsSummary: {
      title: '绩效结果',
      orgAvg: '组织均分',
      gradeDistribution: '等级分布',
      deptComparison: '部门对比',
      deptConfirmProgress: '部门确认进度',
      deptAvg: '均分',
      completionTitle: '完成情况',
      selfEval: '自评',
      managerEval: '上级评',
      e360: '360评估',
      calibration: '校准',
    },
  },

  // 概览页
  overview: {
    title: '绩效概览',
    loading: '加载中...',
    currentCycle: '当前周期',
    noCycle: '暂无进行中的绩效周期',
    noCycleDesc: '请联系 HR 创建新的绩效周期',
    cycleProgress: '周期进度',
    myTasks: '我的待办',
    noTasks: '暂无待办任务',
    noTasksDesc: '所有任务已完成',
    quickActions: '快捷入口',
    dueDate: '截止日期',
    taskKpiSetup: '填写 KPI 目标',
    taskKpiSetupDesc: '尚未创建任何 KPI',
    taskKpiIncomplete: '{count} 个 KPI 待完善',
    taskSelfEval: '完成自评',
    taskSelfEvalDesc: '对本周期各项 KPI 进行自我评估',
    taskE360Config: '配置 360 评估人',
    taskE360ConfigDesc: '选择同事为你进行 360 反馈',
    taskE360Feedback: '完成 360 评估',
    taskE360FeedbackWithName: '为 {name} 完成 360 反馈',
    taskE360FeedbackDue: '截止 {date}',
    taskColleague: '同事',
    mockCycleName: '2025 年度绩效周期',
  },

  // 模块入口
  modules: {
    kpi: {
      title: '我的 KPI',
      desc: '查看 KPI 考核指标与评估进度',
    },
    e360: {
      title: '360 评估',
      desc: '多维度反馈与评估任务',
    },
    result: {
      title: '我的绩效',
      desc: '查看历史绩效结果',
    },
    team: {
      title: '团队绩效',
      desc: '管理团队目标与评估',
    },
  },

  // 周期管理
  cycle: {
    title: '周期管理',
    list: '周期列表',
    create: '创建周期',
    emptyTitle: '暂无周期数据',
    emptyDesc: '请先创建绩效周期',
    emptyAction: '创建第一个周期',
    name: '周期名称',
    organization: '所属组织',
    type: '周期类型',
    status: '状态',
    startDate: '开始日期',
    endDate: '结束日期',
    actions: {
      publish: '发布周期',
      startExecution: '开始执行',
      startEvaluation: '开始评估',
      startCalibration: '开始校准',
      publishResults: '发布结果',
      complete: '完成周期',
      archive: '归档',
      createChild: '创建子周期',
    },
    steps: {
      draft: '草稿',
      goalSetting: '目标设定',
      inProgress: '执行中',
      evaluating: '评估中',
      calibrating: '校准中',
      confirming: '结果确认',
      completed: '已完成',
      archived: '已归档',
    },
    types: {
      ANNUAL: '年度',
      SEMI_ANNUAL: '半年度',
      QUARTERLY: '季度',
      MONTHLY: '月度',
    },
    statuses: {
      DRAFT: '草稿',
      GOAL_SETTING: '目标设定中',
      IN_PROGRESS: '执行中',
      EVALUATING: '评估中',
      CALIBRATING: '校准中',
      CONFIRMING: '结果确认中',
      COMPLETED: '已完成',
      ARCHIVED: '已归档',
    },
    detail: {
      notFound: '周期不存在',
      progressTitle: '周期进度',
      infoTitle: '基本信息',
      statsTitle: '统计概览',
      shortcutsTitle: '快捷入口',
      typeLabel: '周期类型',
      statusLabel: '当前状态',
      startDateLabel: '开始日期',
      endDateLabel: '结束日期',
      statsEmployees: '参与员工',
      statsKpi: 'KPI 评估',
      statsE360: '360 评估',
      statsEmpty: '暂无统计数据',
      shortcutKpi: 'KPI 考核',
      shortcutE360: '360 评估',
      shortcutCalibration: '绩效校准',
    },
    table: {
      name: '周期名称',
      dateRange: '起止日期',
      actions: '操作',
    },
    parentCycle: '父周期',
    childCycles: '子周期',
    noParent: '无（顶层周期）',
    selectParentCycle: '选择父周期',
    createSubtitle: '设置绩效周期的基本信息和时间节点',
    createBasicTitle: '基本信息',
    createDateTitle: '周期日期',
    milestonesTitle: '关键节点',
    milestonesHint: '选填，用于设置各阶段截止时间',
    listSubtitle: '管理绩效周期的完整生命周期',
    searchPlaceholder: '搜索周期名称...',
    filterStatusAll: '全部状态',
    filterTypeAll: '全部类型',
    empty: '暂无周期数据',
    emptyCreate: '创建第一个周期',
    progressLabel: '周期进度',
    pagePrev: '上一页',
    pageNext: '下一页',
    pageLabel: '页码',
    gradeConfig: '等级配置',
    gradeConfigDefault: '使用默认配置',
    gradeConfigDefaultSuffix: '(默认)',
    placeholders: {
      name: '例如：2026 年第一季度绩效周期',
    },
    validation: {
      nameRequired: '请输入周期名称',
      startDateRequired: '请选择开始日期',
      endDateRequired: '请选择结束日期',
      endDateAfterStart: '结束日期必须晚于开始日期',
    },
    toastLoadFailed: '加载失败',
    toastActionFailed: '操作失败',
    toastPublished: '周期已发布',
    toastExecutionStarted: '已进入执行阶段',
    toastEvaluationStarted: '已进入评估阶段',
    toastCalibrationStarted: '已进入校准阶段',
    toastCompleted: '周期已完成',
    toastArchived: '周期已归档',
    toastDeleted: '周期已删除',
    toastCreated: '周期创建成功',
    toastCreateFailed: '创建失败，请重试',
    confirmDelete: '确定要删除此周期吗？此操作不可恢复。',
    confirmDeleteTitle: '删除绩效周期',
    confirmDeleteWithData: '删除此周期将同时移除所有关联的评估数据、KPI 分配等记录，此操作不可恢复。',
  },

  // KPI 管理
  kpi: {
    title: 'KPI 考核',
    my: '我的 KPI',
    subtitle: '查看和评估个人 KPI 考核',
    evaluation: 'KPI 评估',
    evaluationSubtitle: '评估和确认团队成员的 KPI 考核',
    evaluateSubordinates: '评估下属',
    teamKpi: '团队 KPI',
    selectCycle: '选择周期',
    statusAll: '全部状态',
    pendingEvalLabel: '待评估',
    pendingConfirmLabel: '待确认',
    confirmedLabel: '已确认',
    indicator: '指标',
    score: '得分',
    selfScore: '自评分',
    managerScore: '他评分',
    finalScore: '最终得分',
    targetValue: '目标值',
    actualValue: '实际值',
    targetValueLabel: '目标值',
    selfScoreLabel: '自评分',
    managerScoreLabel: '他评分',
    finalScoreLabel: '最终分',
    selfCommentLabel: '自评说明',
    managerCommentLabel: '经理评语',
    stats: {
      total: '总指标数',
      pendingSelfEval: '待自评',
      pendingEval: '待评估',
      pendingConfirm: '待确认',
      confirmed: '已确认',
      avgScore: '平均分',
    },
    emptyData: '暂无 KPI 数据',
    emptyTeam: '暂无待评估 KPI',
    unnamedIndicator: '未命名指标',
    weightLabel: '权重 {weight}%',
    userIndicatorCount: '{count} 个指标',
    userPendingCount: '{count} 个待评估',
    managerEvaluateAction: '评估',
    unknownUser: '未知用户',
    selfEval: {
      title: 'KPI 自评',
      scoreLabel: '自评分数',
      scorePlaceholder: '0-100',
      scoreHint: '请输入 0-100 之间的分数',
      commentLabel: '自评说明',
      commentPlaceholder: '请说明自评依据和完成情况...',
      submit: '提交自评',
      submitting: '提交中...',
    },
    managerEval: {
      title: '经理评估',
      employeeLabel: '员工',
      scoreLabel: '评估分数',
      scorePlaceholder: '0-100',
      commentLabel: '评估意见',
      commentPlaceholder: '请输入评估意见...',
      submit: '提交评估',
      submitting: '提交中...',
      pendingHint: '等待主管评估',
    },
    table: {
      indicator: '指标',
      weight: '权重',
      target: '目标值',
      baseTarget: '基本目标',
      stretchTarget: '挑战目标',
      annualSplit: '年度/季度目标',
      annualTargetPlaceholder: '年度目标',
      annualSplitAction: '年度分解',
      splitting: '分解中...',
      selfEvaluation: '自评',
      managerEvaluation: '他评',
      employee: '员工',
    },
    quarterSummary: '季度合计 {sum} / 年度目标 {annual}',
    createIndicator: '创建指标',
    createIndicatorTitle: '创建指标',
    editIndicatorTitle: '编辑指标',
    searchIndicatorPlaceholder: '搜索指标名称...',
    allCategories: '全部分类',
    emptyIndicators: '暂无指标数据',
    emptyIndicatorCreate: '创建第一个指标',
    indicatorUnitBadge: '单位: {unit}',
    indicatorTargetBadge: '目标: {target}',
    indicatorRangeLabel: '分数范围: {min} - {max}',
    indicatorNameLabel: '指标名称',
    indicatorNamePlaceholder: '请输入指标名称',
    indicatorDescLabel: '描述',
    indicatorDescPlaceholder: '请输入指标描述',
    indicatorCategoryLabel: '分类',
    indicatorCategoryPlaceholder: '如: 销售、技术',
    indicatorUnitLabel: '单位',
    indicatorUnitPlaceholder: '如: %、个、万元',
    indicatorTargetValueLabel: '目标值',
    indicatorMinScoreLabel: '最低分',
    indicatorMaxScoreLabel: '最高分',
    actions: {
      selfEvaluate: '自评',
      managerEvaluate: '他评',
      confirm: '确认',
    },
    validation: {
      scoreRange: '分数必须在 0-100 之间',
      indicatorNameRequired: '请输入指标名称',
      annualTargetRequired: '请输入年度目标值',
      quarterRequired: '请填写所有季度目标',
      quarterSumMismatch: '季度合计需等于年度目标',
    },
    confirmDeleteIndicator: '确定要删除此指标吗？此操作不可撤销。',
    toastLoadFailed: '加载失败',
    toastActionFailed: '操作失败',
    toastSelfSubmitted: '自评已提交',
    toastManagerSubmitted: '评估已提交',
    toastConfirmed: '考核已确认',
    toastIndicatorUpdated: '指标已更新',
    toastIndicatorCreated: '指标已创建',
    toastIndicatorDeleted: '指标已删除',
    toastQuarterUpdated: '季度目标已保存',
    toastQuarterUpdateFailed: '季度目标保存失败',
    statuses: {
      PENDING: '待评估',
      SELF_EVALUATED: '已自评',
      MANAGER_EVALUATED: '主管已评',
      CONFIRMED: '已确认',
    },
    // KPI 分配审批状态
    assignmentStatus: {
      DRAFT: '草稿',
      SUBMITTED: '待审批',
      APPROVED: '已通过',
      REJECTED: '已驳回',
      PENDING_DEPENDENCY: '待确认',
      CONFIRMED: '已确认',
    },
    // 审批相关
    approval: {
      approve: '通过',
      reject: '驳回',
      rejectReason: '驳回原因',
      rejectReasonPlaceholder: '请输入驳回原因...',
      rejectReasonRequired: '请填写驳回原因',
      approveConfirm: '确认通过此 KPI 目标？',
      rejectConfirm: '确认驳回此 KPI 目标？',
      approveAll: '全部通过',
      approveAllConfirm: '确认通过该员工的所有 KPI 目标？',
      goalApproval: '目标审批',
      goalApprovalDesc: '审核下属提交的 KPI 目标',
      noSubmitted: '暂无待审批的 KPI 目标',
      noSubmittedDesc: '下属提交 KPI 目标后将在此显示',
      toastApproved: 'KPI 目标已通过',
      toastRejected: 'KPI 目标已驳回',
      toastApproveAllSuccess: '已通过全部 KPI 目标',
      toastApproveFailed: '审批失败',
      toastRejectFailed: '驳回失败',
      rejectedBanner: '此 KPI 已被主管驳回，请修改后重新提交',
      rejectionReasonLabel: '驳回原因',
      teamOverview: '团队概览',
      teamMembers: '人',
      membersSubmitted: '已提交',
      membersDrafting: '填写中',
      membersNotStarted: '未开始',
    },
    // 依赖确认
    dependency: {
      title: '待确认对齐',
      desc: '以下 KPI 将你列为依赖人，请确认对齐',
      confirmAlign: '确认对齐',
      confirming: '确认中...',
      fromEmployee: '依赖',
      fromEmployeeHint: '请求你协同以下 KPI',
      toastConfirmed: '已确认对齐',
      toastConfirmFailed: '确认失败',
      noPending: '暂无待确认的依赖对齐',
      dialogTitle: '确认依赖对齐',
      selectMyKpi: '选择我的 KPI 进行绑定',
      sourceKpi: '来源 KPI',
      noBinding: '不绑定，直接确认',
      confirm: '确认',
      cancel: '取消',
      reject: '拒绝',
      rejectDialogTitle: '拒绝依赖',
      rejectReasonLabel: '请填写拒绝原因',
      rejectReasonPlaceholder: '说明拒绝的原因...',
      toastRejected: '已拒绝依赖',
      toastRejectFailed: '拒绝失败',
      descriptionPlaceholder: '描述你对协同人的需求...',
      descriptionLabel: '需求描述',
      rejectionReasonLabel: '拒绝原因',
      pending: '待确认',
      confirmed: '已确认',
      rejected: '已拒绝',
      removeDialogTitle: '移除依赖',
      removeDialogDesc: '确定要移除对 {name} 的依赖吗？相关的需求描述也会一并清除。',
      removeConfirm: '确定移除',
    },
    // 阶段提示
    phase: {
      goalSetting: {
        title: '目标设定阶段',
        desc: '请确认您的 KPI 目标并完成季度分解',
        submitAll: '提交目标',
        submitting: '提交中...',
        toastSubmitted: 'KPI 目标已提交',
        toastSubmitFailed: '提交失败',
      },
      inProgress: {
        title: '执行阶段',
        desc: '当前处于执行阶段，请按计划推进 KPI 目标',
      },
      evaluating: {
        title: '评估阶段',
        desc: '请完成 KPI 自评',
      },
      calibrating: {
        title: '校准阶段',
        desc: '评估结果正在进行校准，最终结果可能会根据校准有所调整',
      },
      readonly: {
        title: '当前周期',
        desc: '查看 KPI 目标与评估结果',
      },
    },
    cycleDraft: {
      title: '周期尚未发布',
      desc: '当前周期处于草稿状态，请等待 HR 发布后再开始填写 KPI 目标',
    },
    empty: '暂无 KPI',
    emptyDesc: '点击下方按钮添加你的 KPI',
    // 自由填写添加 KPI
    addKpi: '添加 KPI',
    addKpiTitle: '添加 KPI',
    confirmAdd: '确认添加',
    toastKpiAdded: 'KPI 已添加',
    toastAddKpiFailed: '添加 KPI 失败',
    indicatorsEmptyTitle: '暂无指标数据',
    indicatorsEmptyDesc: '请先创建 KPI 指标',
    indicatorsEmptyAction: '创建第一个指标',
    evaluationEmptyTitle: '暂无待评估 KPI',
    evaluationEmptyDesc: '所有 KPI 已完成评估',

    // /performance/kpi 页面细节文案
    page: {
      indicatorNamePlaceholder: '输入 KPI 名称',
      childNamePlaceholder: '{quarter} 任务名称',
      addQuarterTask: '添加季度任务',
      saveTargets: '保存',
      quarterTargetsLabel: '季度目标',
      autoSplit: '平均分配',
      annualTargetLabel: '年度目标: {value}',
      scoreUnit: '分',
      notSubmitted: '未提交',
      pendingManagerEvaluation: '待评估',
      needSelfEvaluationFirst: '需先完成自评',
      showGuideTitle: '显示填写指南',
      deleteKpiAriaLabel: '删除 KPI',
      deleteChildAriaLabel: '删除子任务',
      baseTargetPlaceholder: '输入基本目标（如「签约 30 家客户」）',
      stretchTargetPlaceholder: '输入挑战目标（如「签约 50 家客户」）',
      draftNamePlaceholder: '输入 KPI 名称（如「Q1 新客户签约 50 家」）',
      weightLabel: '权重',
      deleteDraftAriaLabel: '删除草稿',
      draftHint: '填写完成后点击保存，或继续添加更多 KPI',
      saveDraft: '保存此项',
      saveAllDrafts: '全部保存',
      cancelDrafts: '取消',
      pendingSaveCount: '{count} 条待保存',
      submitDisabledHint: '请先保存所有草稿',
      submitDisabledHintWeight: '当前总权重为 {weight}%，请调整为 100% 后再提交',
      submitDisabledHintTargets: '请先为每个年度 KPI 生成 Q1-Q4（4 条子 KPI），并确保每个年度下子 KPI 权重合计为 100%',
      submitDisabledHintIncomplete: '请确保所有 KPI 填写完整且依赖已确认',
      totalWeightLabel: '总权重 {weight}%',
      weightWarning: '当前 KPI 总权重为 {weight}%，需调整为 100%',
      guideButton: '指南',
      toastQuarterCreated: '已生成 Q1-Q4 子 KPI',
      toastQuarterCreateFailed: '生成季度 KPI 失败',
      toastQuarterAlreadyExists: '该年度 KPI 已存在季度 KPI',
      toastDependentUserSet: '已设置依赖人：{name}',
      toastDependentUserRemoved: '已移除依赖人',
      toastDependentUserFailed: '设置依赖人失败',
      toastUpdateDescriptionFailed: '更新描述失败',
      toastUpdateNameFailed: '更新名称失败',
      toastUpdateWeightFailed: '更新权重失败',
      toastRowSaved: '已保存',
      toastDeletedKpi: '已删除 KPI',
      toastDeleteFailed: '删除失败',
      toastAddChildFailed: '添加子任务失败',
      toastUpdateChildNameFailed: '更新子任务名称失败',
      toastUpdateChildWeightFailed: '更新子任务权重失败',
      toastDeletedChild: '已删除子任务',
      toastDeleteChildFailed: '删除子任务失败',
      validation: {
        weightRequired: '请填写权重',
        weightRange: '权重应在 1-100 之间',
      },

      table: {
        name: '绩效名',
        weight: '权重',
        baseTarget: '基本目标',
        stretchTarget: '挑战目标',
        dependentUser: '依赖人',
        dependentKpi: '依赖绩效',
        status: '状态',
        actions: '操作',
        annual: '年度',
        expand: '展开',
        collapse: '收起',
        addQuarter: '生成 Q1-Q4',
        creatingQuarter: '生成中...',
        delete: '删除',
        decomposeTitle: '季度 KPI（父子关系）',
        decomposeHint: '当前已生成 {count}/4 条子 KPI，子 KPI 权重合计 {sum}%',
        decomposeMissing: '需要生成完整 Q1-Q4 4 条子 KPI',
        evaluation: '评估',
        save: '保存',
        saving: '保存中...',
        remove: '移除',
      },
    },

    // 行内 @ 选人
    mentionPicker: {
      removeTitle: '点击移除',
      cancel: '取消',
      selectUser: '@选人',
      searchPlaceholder: '搜索姓名',
      notFound: '未找到',
      typeToSearch: '输入姓名搜索',
    },

    // 右侧填写指南
    guide: {
      tabs: {
        guide: '填写指南',
        examples: '最佳范例',
      },
      badLabel: 'Bad',
      goodLabel: 'Good',
      weightLabel: '权重 {weight}%',
      suggestions: {
        title: '填写建议',
        count: '当前有 {count} 条建议',
        tooShort: '「{name}」描述过于简短，建议更具体地描述要达成的状态',
        missingNumber: '「{name}」缺少量化指标，建议加入具体数字（如「签约 50 家」）',
        missingDesc: '「{name}」建议补充衡量方式或达成标准',
      },
      howToTitle: '如何写好 KPI？',
      sections: [
        { title: '描述目标要具体且有方向性', bad: '提高英文水平', good: '半年后，可以用英文做专业领域的分享' },
        { title: '制定目标要有挑战性', bad: '十年后，可以用英文做专业领域的分享', good: '半年后，可以用英文做专业领域的分享' },
        { title: '定量或定性地描述 KPI', bad: '背诵专业词汇', good: '能熟练使用 200 个专业领域的词汇和表达' },
        { title: 'KPI 应可衡量、可验证', bad: '能用英文制作专业领域 PPT', good: '能用英文制作专业领域 PPT，可以准确解释专业概念' },
      ],
      principlesTitle: '其他制定原则',
      principles: [
        '每人 KPI 数量应控制在 3-7 个',
        '所有 KPI 权重之和应为 100%',
        '不要只写一个模糊的词（如「XX 项目」、「其他」、「重点项目」）',
        '描述清楚要达成的状态，而非只列任务名称',
      ],
      exampleGroups: [
        {
          title: '销售类',
          items: [
            { name: 'Q1 新客户签约 50 家', desc: '通过线上渠道和线下拜访，新签约企业客户 50 家，单客户合同额不低于 5 万元', weight: 30 },
            { name: '季度回款率达到 95%', desc: '确保已签约客户按合同约定时间完成付款，逾期率不超过 5%', weight: 20 },
          ],
        },
        {
          title: '技术类',
          items: [
            { name: '核心系统可用性达到 99.9%', desc: '通过架构优化和监控告警，确保生产环境全年可用时间大于 99.9%，P0 故障不超过 2 次', weight: 25 },
            { name: '代码评审覆盖率 100%', desc: '所有合并到主分支的代码必须经过至少 1 人评审，评审意见 48 小时内处理', weight: 15 },
          ],
        },
        {
          title: '管理类',
          items: [
            { name: '团队满意度评分不低于 4.2', desc: '通过定期 1:1、团建活动和职业发展沟通，季度匿名调研满意度不低于 4.2/5.0', weight: 20 },
            { name: '关键岗位后备人才储备率 80%', desc: '为团队内每个关键岗位至少培养 1 名后备人选，完成 IDP 制定和定期 Review', weight: 15 },
          ],
        },
      ],
    },
  },

  // 360 评估
  e360: {
    title: '360 评估',
    subtitle: '管理 360 度多维评估',
    my: '我的评估',
    feedback: '反馈任务',
    evaluators: '评估人',
    relationship: '关系',
    anonymity: '匿名级别',
    addEvaluator: '添加评估人',
    pendingTasks: '待完成评估',
    create: '创建评估',
    filterCycle: '选择周期',
    statusAll: '全部状态',
    statsTotal: '总评估数',
    empty: '暂无 360 评估数据',
    emptyCreate: '创建第一个评估',
    cardTitle: '360 评估',
    evaluateeLabel: '被评估人',
    progressCompleted: '完成',
    modalTitle: '创建 360 评估',
    modalTitleLabel: '评估标题',
    modalTitlePlaceholder: '请输入评估标题',
    modalDescLabel: '描述',
    modalDescPlaceholder: '请输入评估描述',
    modalEvaluateeLabel: '被评估人',
    modalEvaluateePlaceholder: '请输入被评估人 ID',
    modalEvaluateeHelper: 'TODO: 替换为用户选择器组件',
    modalAnonymityLabel: '匿名级别',
    anonymityNone: '完全透明',
    anonymityPartial: '部分匿名（显示关系类型）',
    anonymityFull: '完全匿名',
    toastLoadFailed: '加载失败',
    toastTitleRequired: '请输入评估标题',
    toastEvaluateeRequired: '请选择被评估人',
    toastCreated: '评估已创建',
    toastActionFailed: '操作失败',
    toastStarted: '评估已启动',
    toastCompleted: '评估已完成',
    actions: {
      start: '启动评估',
      complete: '完成收集',
      submit: '提交反馈',
    },
    detail: {
      title: '360 评估详情',
      notFound: '评估不存在',
      infoTitle: '评估信息',
      evaluatorCountLabel: '评估人数',
      evaluatorCountValue: '{count} 人',
      resultTitle: '评估结果',
      radarHint: '评分范围为 1-5 分',
      radarEmpty: '暂无维度得分',
      dimensionScores: '各维度得分',
      overallScore: '综合得分',
      evaluatorListTitle: '评估人列表',
      completedSummary: '{completed}/{total} 已完成',
      emptyEvaluators: '暂无评估人',
      emptyAddEvaluator: '添加第一个评估人',
      unknownUser: '未知用户',
      taskCompleted: '已完成',
      taskPending: '待完成',
      progressTitle: '完成进度',
      progressCompletedLabel: '已完成',
      progressEmpty: '请先添加评估人',
      progressNoneCompleted: '暂无人完成评估',
      progressRemaining: '还有 {count} 人未完成',
      progressAllCompleted: '所有评估人已完成',
      timelineTitle: '状态记录',
      timelineCreated: '创建评估',
      timelineStarted: '启动评估',
      timelineCompleted: '完成评估',
      feedbackListTitle: '反馈列表',
      feedbackListEmpty: '暂无反馈内容',
      addEvaluatorTitle: '添加评估人',
      evaluatorLabel: '评估人',
      evaluatorPlaceholder: '请输入评估人 ID',
      evaluatorHelper: 'TODO: 替换为用户选择器',
      relationshipLabel: '与被评估人关系',
      evaluatorRequired: '请输入评估人 ID',
      evaluatorAdded: '评估人已添加',
      evaluatorRemoved: '评估人已移除',
      confirmRemoveEvaluator: '确定要移除此评估人吗？',
      completeAction: '结束评估',
    },
    statuses: {
      DRAFT: '草稿',
      IN_PROGRESS: '进行中',
      COMPLETED: '已完成',
    },
    relationships: {
      SELF: '自评',
      SUPERIOR: '上级',
      SUPERVISOR: '上级',
      PEER: '同事',
      SUBORDINATE: '下属',
      EXTERNAL: '外部',
    },
  },

  // 360 反馈
  e360Feedback: {
    title: '待完成的评估',
    subtitle: '完成分配给您的 360 评估任务',
    anonymousTitle: '匿名评估说明',
    anonymousDesc: '您的反馈将根据评估设置进行匿名处理，请放心提供真实、客观的评价。',
    anonymousHint: '您的反馈将进行匿名处理',
    guideTitle: '评估须知',
    guideConfidential: '您的回答是保密且匿名的。所有反馈将进行聚合报告，不会标识个人贡献者。',
    guideHonest: '请根据您与该领导的直接工作经验，诚实、建设性地作答。您的意见对支持领导力成长和组织效能至关重要。',
    guideScaleTitle: '评分标准 (1-5)',
    guideScale1: '1 — 非常不同意',
    guideScale2: '2 — 不同意',
    guideScale3: '3 — 中立 / 尚可',
    guideScale4: '4 — 同意',
    guideScale5: '5 — 非常同意 / 堪称典范',
    empty: '暂无待完成的评估任务',
    emptyHint: '当同事邀请你进行 360 评估时会显示在这里',
    pendingTitle: '待完成',
    completedTitle: '已完成',
    statusCompleted: '已完成',
    statusOverdue: '已逾期',
    statusCancelled: '已取消',
    statusPending: '待评估',
    evaluateeLabel: '被评估人',
    scoreLabel: '评分',
    scorePlaceholder: '请选择评分',
    relationshipLabel: '您的关系',
    dueDateLabel: '截止日期',
    dueDatePrefix: '截止',
    submittedAtPrefix: '提交于',
    fillFeedback: '填写反馈',
    evaluateTitle: '评估',
    anonymousBadge: '匿名评估',
    dimCommentPlaceholder: '简短评语（可选）',
    cancelAction: '取消',
    submitAction: '提交评估',
    modalTitle: '提交评估反馈',
    scoreLow: '需改进',
    scoreHigh: '优秀',
    commentPlaceholder: '补充说明（可选）',
    overallLabel: '综合评语',
    overallPlaceholder: '请提供对该同事的整体评价和改进建议...',
    unknown: '未知',
    unknownUser: '未知用户',
    tabTasks: '待我评估',
    tabResults: '我的结果',
    aggregateScore: '综合分',
    respondentCount: '人',
    feedbackSummary: '反馈摘要',
    noResultsHint: '在 KPI 自评时配置 360 评估人后，结果会显示在这里',
    toastLoadFailed: '加载失败',
    toastScoreRequired: '请为所有维度评分',
    toastSubmitted: '反馈已提交',
    toastActionFailed: '操作失败',
    dimensions: {
      communication: {
        name: '沟通能力',
        desc: '有效表达和倾听的能力',
      },
      teamwork: {
        name: '团队协作',
        desc: '与团队成员协作完成目标的能力',
      },
      leadership: {
        name: '领导力',
        desc: '带领和激励团队的能力',
      },
      professional: {
        name: '专业能力',
        desc: '专业知识和技能水平',
      },
      innovation: {
        name: '创新能力',
        desc: '提出新想法和解决问题的能力',
      },
    },
  },

  // 360 评估与 KPI 集成
  e360Kpi: {
    sectionTitle: '360 互评配置',
    sectionDesc: '选择对你进行 360 评估的同事，提交自评后将自动发送评估请求',
    addEvaluator: '添加评估人',
    selectUser: '选择同事',
    selectRelationship: '选择关系',
    noEvaluators: '尚未添加评估人',
    addHint: '建议添加 3-5 位评估人，覆盖上级、同级和下级',
    referenceTitle: '360 评估参考',
    aggregateScore: '360 综合分',
    dimensionScores: '维度得分',
    evaluatorCount: '评估人数',
    pendingCount: '待评估',
    completedCount: '已完成',
    noResults: '暂无 360 评估数据',
    viewDetail: '查看 360 详情',
    relationship: {
      SUPERVISOR: '上级',
      PEER: '同级',
      SUBORDINATE: '下级',
    },
  },

  // 校准
  calibration: {
    title: '绩效校准',
    subtitle: '查看评估结果分布，调整员工等级，确保公平一致',
    // 概览统计
    overview: {
      totalEmployees: '参评人数',
      avgScore: '平均分',
      medianScore: '中位数',
      persons: '人',
    },
    // 等级分布
    distribution: '等级分布',
    distributionHint: '目标分布线',
    targetActualLabel: '目标 | 实际',
    targetActualValue: '{target}% | {actual}%',
    targetLabel: '目标: {target}%',
    // 员工排名表
    ranking: {
      title: '员工评分排名',
      rank: '排名',
      employee: '员工',
      kpiCount: 'KPI 数',
      selfScore: '自评加权',
      managerScore: '主管加权',
      diff: '差异',
      grade: '等级',
      calibratedGrade: '校准等级',
      calibrationScore: '校准分',
      note: '校准备注',
      action: '操作',
      expand: '展开 KPI 明细',
      collapse: '收起',
      save: '保存',
      saved: '已保存',
    },
    // KPI 明细
    kpiDetail: {
      indicator: '指标',
      weight: '权重',
      selfScore: '自评',
      managerScore: '主管评',
      selfComment: '自评说明',
      managerComment: '主管评语',
    },
    // 空状态
    empty: '暂无校准数据',
    emptyHint: '请先选择处于校准阶段的绩效周期',
    noCalibratingCycle: '暂无处于校准阶段的周期',
    // 周期选择
    cycleLabel: '绩效周期',
    cyclePlaceholder: '请选择周期',
    // 等级
    grades: {
      S: '卓越',
      A: '优秀',
      B: '良好',
      C: '待改进',
      D: '不合格',
    },
    // Toast
    toastLoadFailed: '加载校准数据失败',
    toastSaved: '校准已保存',
    toastSaveFailed: '保存失败',
    adjust: '调整等级',
    reason: '调整原因',
    reasonPlaceholder: '请详细说明调整等级的原因...',
    logs: '调整记录',
    emptyEmployees: '暂无员工',
    totalScoreLabel: '综合分',
    scoreLabel: '得分',
    originalGradeLabel: '原等级',
    currentGradeLabel: '当前等级',
    newGradeLabel: '调整后等级',
    notFound: '校准会议不存在',
    historyTitle: '等级调整记录',
    historyEmpty: '暂无调整记录',
    adjustedByLabel: '调整人: {name}',
    createTitle: '创建校准会议',
    cycleEmptyHint: '暂无处于校准阶段的周期，请先将周期推进到校准阶段',
    nameLabel: '会议名称',
    namePlaceholder: '例如：2024年Q1销售部门校准会议',
    descLabel: '会议描述',
    descPlaceholder: '会议目的和议程说明...',
    scheduledLabel: '计划时间',
    completedLabel: '完成',
    participantsCount: '{count} 名参与者',
    emptyCreate: '创建第一个校准会议',
    confirmAdjustTitle: '确认等级调整',
    filters: {
      allCycles: '全部周期',
      allStatuses: '全部状态',
    },
    actions: {
      create: '创建会议',
      start: '开始校准',
      complete: '完成校准',
    },
    table: {
      employee: '员工',
      score: '得分',
      currentGrade: '当前等级',
      adjustGrade: '调整等级',
      reason: '调整原因',
    },
    statuses: {
      SCHEDULED: '已安排',
      IN_PROGRESS: '进行中',
      COMPLETED: '已完成',
    },
    validation: {
      required: '请填写必填项',
      adjustReasonRequired: '请填写调整原因',
      adjustGradeRequired: '请选择不同的目标等级',
    },
    toastCreated: '校准会议已创建',
    toastCreateFailed: '创建失败',
    toastStarted: '校准会议已开始',
    toastCompleted: '校准会议已完成',
    toastDeleted: '校准会议已删除',
    toastAdjusted: '等级已调整',
    toastAdjustFailed: '调整失败',
    toastActionFailed: '操作失败',
    cycleLoadFailed: '加载周期失败',
  },

  settings: {
    grades: {
      title: '等级配置',
      subtitle: '管理绩效等级体系',
      createAction: '新建配置',
      listTitle: '配置列表',
      empty: '暂无配置',
      emptyCreate: '创建第一个配置',
      defaultBadge: '默认',
      detailCreateTitle: '新建配置',
      detailTitle: '配置详情',
      detailEmptyTitle: '选择配置',
      detailEmptyHint: '选择左侧配置查看详情',
      detailEmptyAction: '或点击"新建配置"创建新的等级体系',
      nameLabel: '配置名称',
      namePlaceholder: '输入配置名称',
      descLabel: '描述',
      descPlaceholder: '配置描述（可选）',
      weightsLabel: '评分权重',
      selfEvalWeight: '员工自评',
      managerEvalWeight: '主管评分',
      weightsSumError: '权重之和必须等于 100%',
      levelsLabel: '等级设置',
      codePlaceholder: '代码',
      levelNamePlaceholder: '名称',
      minScorePlaceholder: '最低分',
      maxScorePlaceholder: '最高分',
      addLevelAction: '+ 添加等级',
      editAction: '编辑配置',
      setDefaultAction: '设为默认',
      notesTitle: '配置说明',
      notes: {
        code: '等级代码建议使用单个大写字母（如 S、A、B、C、D）',
        range: '分数区间应从高到低设置，确保不重叠',
        defaultApply: '默认配置将应用于新创建的周期',
        history: '修改配置不会影响已完成的绩效周期',
      },
      defaults: {
        S: { name: '卓越', description: '超出预期完成目标' },
        A: { name: '优秀', description: '高质量完成目标' },
        B: { name: '良好', description: '符合预期完成目标' },
        C: { name: '待改进', description: '部分完成目标' },
        D: { name: '不合格', description: '未能完成目标' },
      },
      validation: {
        nameRequired: '请输入配置名称',
        gradeRequired: '请至少添加一个等级',
        gradeCodeRequired: '等级代码和名称不能为空',
        minScoreGreaterThanMax: '等级 {code} 的最低分不能大于最高分',
      },
      toastLoadFailed: '加载失败',
      toastCreated: '配置已创建',
      toastUpdated: '配置已更新',
      toastSaveFailed: '保存失败',
      toastDeleteDefault: '不能删除默认配置',
      confirmDelete: '确定要删除这个配置吗？',
      toastDeleted: '配置已删除',
      toastDeleteFailed: '删除失败',
      toastAlreadyDefault: '已经是默认配置',
      toastSetDefault: '已设为默认配置',
      toastActionFailed: '操作失败',
    },
    e360Templates: {
      title: '360 模板',
      createAction: '新建模板',
      listTitle: '模板列表',
      empty: '暂无模板',
      emptyCreate: '创建第一个模板',
      defaultBadge: '默认',
      detailCreateTitle: '新建模板',
      detailTitle: '模板详情',
      detailEmptyTitle: '选择模板',
      detailEmptyHint: '选择左侧模板查看详情',
      nameLabel: '模板名称',
      namePlaceholder: '输入模板名称',
      descLabel: '描述',
      descPlaceholder: '模板描述（可选）',
      relationshipsLabel: '评估关系类型',
      dimensionsLabel: '评估维度',
      dimNamePlaceholder: '维度名称，如"沟通与人际能力"',
      dimNameEnPlaceholder: 'Name (English), e.g. "Communication & Interpersonal Skills"',
      dimDescPlaceholder: '维度描述 — 评估时展示给评估人',
      dimDescEnPlaceholder: 'Description in English — shown to evaluators',
      addDimensionAction: '+ 添加维度',
      editAction: '编辑模板',
      setDefaultAction: '设为默认',
      notesTitle: '使用说明',
      notes: {
        dimensions: '评估维度会在 360 反馈表单中展示，每个维度使用 1-5 分制',
        relationships: '关系类型决定了哪些角色的人可以参与评估',
        defaultApply: '默认模板将应用于新创建的 360 评估',
        anonymous: '所有 360 评估反馈均为匿名，结果按关系类型聚合展示',
      },
      validation: {
        nameRequired: '请输入模板名称',
        dimensionRequired: '请至少添加一个评估维度',
        relationshipRequired: '请至少选择一个关系类型',
      },
      toastLoadFailed: '加载失败',
      toastCreated: '模板已创建',
      toastUpdated: '模板已更新',
      toastSaveFailed: '保存失败',
      toastDeleteDefault: '不能删除默认模板',
      confirmDelete: '确定要删除这个模板吗？',
      toastDeleted: '模板已删除',
      toastDeleteFailed: '删除失败',
      toastSetDefault: '已设为默认模板',
      toastActionFailed: '操作失败',
    },
  },

  // 结果
  result: {
    title: '绩效结果',
    my: '我的绩效',
    admin: '结果管理',
    grade: '绩效等级',
    totalScore: '综合得分',
    publish: '发布结果',
    export: '导出报告',
    viewed: '已查看',
    notViewed: '未查看',
    pageTitle: '我的绩效结果',
    pageSubtitle: '查看您的历史绩效评估结果',
    emptyTitle: '暂无绩效结果',
    emptyDesc: '结果发布后将在此处显示',
    publishedAt: '发布于',
    unpublished: '未发布',
    pending: '待发布',
    scoreUnit: '分',
    trendUp: '较上期 +',
    trendDown: '较上期 ',
    trendSame: '与上期持平',
    kpiScore: 'KPI 得分',
    e360Score: '360 得分',
    remarks: '评语',
    trendTitle: '绩效趋势',
    detailTitle: '结果明细',
    gradeDescriptionLabel: '等级说明',
    gradeDescriptionEmpty: '暂无等级说明',
    scoreBreakdownTitle: '分数明细',
    scoreBreakdownIndicator: '指标',
    scoreBreakdownScore: '得分',
    scoreBreakdownWeight: '权重',
    scoreBreakdownEmpty: '暂无分数明细',
    selectHint: '请从右侧选择一个周期查看结果',
    historyTitle: '历史结果',
    noteTitle: '绩效结果说明',
    noteDesc: '绩效结果由 KPI 和 360 评估综合计算得出。如有疑问，请联系您的直接上级或 HR。',
    toastLoadFailed: '加载失败',
  },

  // 结果管理
  resultsAdmin: {
    title: '绩效结果管理',
    subtitle: '计算、发布和管理绩效结果',
    calculate: '计算结果',
    publishAll: '发布全部',
    publishSelected: '发布选中',
    export: '导出',
    filterCycle: '选择周期',
    filterGradeAll: '全部等级',
    filterStatusAll: '全部状态',
    statusPublished: '已发布',
    statusUnpublished: '未发布',
    statusViewed: '已查看',
    statsTotal: '总人数',
    statsCalculated: '已计算',
    statsPublished: '已发布',
    statsViewed: '已查看',
    selectCycleHint: '请选择一个周期查看结果',
    emptyResults: '暂无结果数据',
    tableEmployee: '员工',
    tableScore: '综合分',
    tableGrade: '等级',
    tableStatus: '状态',
    pagePrev: '上一页',
    pageNext: '下一页',
    gradeDistributionTitle: '等级分布',
    noData: '暂无数据',
    avgScore: '平均分',
    exportFilePrefix: '绩效结果',
    toastLoadFailed: '加载失败',
    toastSelectCycle: '请先选择周期',
    toastCalculated: '结果计算完成',
    toastCalculateFailed: '计算失败',
    toastPublished: '结果已发布',
    toastPublishFailed: '发布失败',
    toastExported: '导出成功',
    toastExportFailed: '导出失败',
    logLoadCyclesFailed: '加载周期失败',
    statsConfirmed: '已确认',
    statsAppealed: '申诉中',
    confirmStatusConfirmed: '已确认',
    confirmStatusAppealed: '申诉中',
    confirmStatusPending: '待确认',
    confirmStatusResolved: '申诉已处理',
    appealReasonLabel: '申诉原因',
  },

  // 结果确认
  resultConfirm: {
    title: '绩效结果确认',
    pendingHint: '请查看您的绩效结果并确认',
    confirmDesc: '请查看并确认您的绩效评定结果',
    confirmBtn: '确认结果',
    appealBtn: '提出申诉',
    confirmedLabel: '已确认',
    confirmedAt: '确认于',
    appealedLabel: '已提交申诉',
    appealedAt: '申诉于',
    appealResolvedLabel: '申诉已处理',
    appealModalTitle: '绩效申诉',
    appealModalDesc: '请说明您对绩效结果的异议，HR 将在收到后进行复核。',
    appealReasonPlaceholder: '请详细描述您对评估结果的异议原因...',
    appealReasonRequired: '请填写申诉原因',
    appealSubmit: '提交申诉',
    appealCancel: '取消',
    toastConfirmed: '已确认绩效结果',
    toastAppealed: '申诉已提交',
    toastFailed: '操作失败',
    recentResult: '最近绩效结果',
    noResult: '暂无已发布的绩效结果',
    viewDetail: '查看详情',
    scoreUnit: '分',
    trendSame: '持平',
    resultTip: '绩效结果在周期结束后由主管评估并经校准后发布。点击「查看详情」可查看 KPI 得分、360 评估及评语等完整信息。',
    // 结果确认详情页
    detailTitle: '绩效结果确认',
    overallResult: '综合评定',
    kpiBreakdown: 'KPI 得分明细',
    calibrationNote: '校准调整',
    calibrationDesc: '您的评分经过管理层校准会议调整',
    originalScoreLabel: '原始评分',
    calibratedScoreLabel: '校准后评分',
    selfScoreLabel: '自评',
    managerScoreLabel: '主管评分',
    finalScoreLabel: '校准后',
    weightLabel: '权重',
    commentLabel: '评语',
    noComment: '暂无评语',
    e360Summary: '360 评估',
    e360Desc: '360 评估仅作为参考，不计入最终评分',
    backToOverview: '返回概览',
    alreadyConfirmed: '您已于 {date} 确认此结果',
    alreadyAppealed: '您已于 {date} 提交申诉',
    collapseKpiDetails: '收起 KPI 明细',
    expandKpiDetails: '查看 KPI 明细',
  },

  // 等级配置
  grade: {
    title: '等级配置',
    name: '等级名称',
    code: '等级代码',
    minScore: '最低分',
    maxScore: '最高分',
    color: '颜色',
    default: '默认配置',
    setDefault: '设为默认',
  },

  // 统计
  stats: {
    kpiCompletion: 'KPI 目标完成',
    kpiEvaluation: 'KPI 评估',
    e360Tasks: '360 任务',
    e360Completion: '360 完成率',
    gradeDistribution: '等级分布',
  },

  // 统计分析
  analytics: {
    title: '统计分析',
    subtitle: '查看绩效数据统计和分析报表',
    filterTitle: '报表筛选',
    noData: '暂无数据',
    selectCycle: '请选择周期',
    selectCyclePlaceholder: '选择周期',
    departmentAll: '全部部门',
    tabPersonal: '个人报表',
    tabTeam: '团队报表',
    tabCompany: '公司报表',
    kpiIndicators: 'KPI 指标',
    selfEvaluated: '自评完成',
    managerEvaluated: '主管已评',
    avgScore: '平均得分',
    evaluation360Tasks: '360 评估任务',
    pending: '待完成',
    completed: '已完成',
    trendTitle: '历史绩效趋势',
    scoreUnit: '分',
    latestScore: '最新得分',
    changeFromLast: '较上期变化',
    trendHighestScore: '历史最高',
    averageScore: '平均得分',
    teamSize: '团队规模',
    kpiAverage: 'KPI 平均分',
    highLowScore: '最高/最低分',
    gradeDistribution: '等级分布',
    totalEmployees: '参与人数',
    highestScore: '最高分',
    lowestScore: '最低分',
    averagesTitle: '各项平均分',
    kpiLabel: 'KPI',
    e360Label: '360',
    completionTitle: '完成度统计',
    kpiCompletionRate: 'KPI 评估率',
    e360CompletionRate: '360 完成率',
    departmentRanking: '部门排名',
    employeeCountUnit: '人',
    tabDepartment: '部门报表',
    selectDepartment: '选择部门',
    selectDepartmentHint: '请选择一个部门查看报表',
    deptEmployeeCount: '部门人数',
    scoreDistribution: '分数段分布',
    evalProgress: '评估完成进度',
    kpiEval: 'KPI 评估',
    e360Eval: '360 评估',
    kpiIndicatorCount: '{count} 项指标',
    e360CompletedCount: '{completed}/{total} 已完成',
    kpiEvaluatedCount: '{evaluated}/{total} 已评估',
    kpiAvg: 'KPI 平均',
    e360Avg: '360 平均',
    topDept: '最高部门',
    bottomDept: '最低部门',
  },

  // 战略目标
  strategic: {
    title: '战略目标',
    subtitle: '定义组织战略目标并分配给指定人员',
    create: '创建目标',
    createTitle: '创建战略目标',
    editTitle: '编辑战略目标',
    nameLabel: '目标名称',
    namePlaceholder: '请输入战略目标名称',
    descLabel: '描述',
    descPlaceholder: '请输入目标描述（可选）',
    seqLabel: '序号',
    departmentLabel: '责任部门',
    selectDepartment: '选择责任部门',
    searchDepartment: '搜索部门...',
    noDepartments: '未找到部门',
    selectAssignees: '选择责任人',
    selectCycle: '选择周期',
    selectCycleHint: '请先选择绩效周期',
    empty: '暂无战略目标',
    emptyCreate: '创建第一个战略目标',
    assignees: '负责人',
    noAssignees: '暂无',
    addAssignee: '添加',
    assigneePlaceholder: '输入用户 ID（多个用逗号分隔）',
    confirmDeleteTitle: '删除战略目标',
    confirmDeleteDesc: '确定要删除此战略目标吗？关联的人员分配将一并移除。',
    validation: {
      nameRequired: '请输入目标名称',
    },
    toastLoadFailed: '加载失败',
    toastCreated: '目标已创建',
    toastUpdated: '目标已更新',
    toastDeleted: '目标已删除',
    toastAssigned: '人员已分配',
    toastActionFailed: '操作失败',
    actionsColumn: '操作',
    searchNoMatch: '未找到匹配人员',
    searchHint: '输入姓名搜索',
  },

  // 通用
  common: {
    viewDetail: '查看详情',
    viewAll: '查看全部',
    submit: '提交',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    required: '必填',
    optional: '选填',
    comment: '评语',
    attachment: '附件',
    noData: '暂无数据',
  },
};
